<template>
  <div class="Feedback-type-item-main" :class="{ 'Feedback-type-item-main-mobile': isMobile }">
    <div class="title" :style="{ backgroundImage: `url(${data.bgImage})` }"> {{ data.title }}</div>
    <div class="content" @click="click(data.id)" v-html="data.content"></div>
  </div>
</template>
<script>
export default {
  name: 'FeedbackTypeItem',
  props: {
    data: {
      type: Object,
      default: () => {}
    }
  }
};
</script>
<style lang="scss" scoped>
.Feedback-type-item-main {
  margin: 0 0.135rem;
  border-radius: 0.03rem;
  width: 6.76rem;
  height: 4.27rem;
  background: #fff;
  box-shadow: 0 0.03rem 0.16rem 0.03rem rgb(226 226 226 / 59%);
}
.title {
  width: 7.13rem;
  height: 1.2rem;
  background-repeat: no-repeat;
  background-size: 100%;
  background-position: -0.2rem;
  font-size: 0.32rem;
  font-family: PingFangTC-Medium, PingFangTC;
  font-weight: 500;
  color: #ffffff;
  line-height: 1.2rem;
  letter-spacing: 0.01rem;
  padding-left: 0.69rem;
}
.content {
  font-size: 0.27rem;
  font-family: PingFangTC-Regular, PingFangTC;
  font-weight: 400;
  color: #000000;
  line-height: 0.49rem;
  letter-spacing: 0.01rem;
  padding: 0.44rem 0.57rem 0 0.69rem;
}
.Feedback-type-item-main-mobile {
  margin: 1.02rem 0 0;
  border-radius: 0.1rem;
  width: 17.15rem;
  height: auto;
  box-shadow: 0px 10px 61px 10px rgba(226, 226, 226, 0.59);
  .title {
    width: 100%;
    height: 4.04rem;
    background-size: 105% 115%;
    background-position: -0.4rem -0.4rem;
    font-size: 0.82rem;
    line-height: 4.04rem;
    letter-spacing: 0.05rem;
    padding-left: 1.18rem;
  }
  .content {
    font-size: 0.72rem;
    line-height: 1.59rem;
    padding: 1rem 0.8rem 1.02rem;
    text-align: justify;
    color: #4a4a4a;
  }
}
</style>
